/* eslint-disable camelcase */
import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import searchFilterTerms from "@tKgpco/Handlers/Terms/SearchFilterTerms";
import { uploadTermsApi } from "@tKgpco/Services/TermsService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";
import { QuoteTerms } from "@tKgpco/Store/Data/Terms/TermsState";

type Parameters = any & HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters, QuoteTerms>;

export const PopulateApiParameters: HandlerType = props => {
    const { file } = props.parameter;
    props.apiParameter = {
        file,
    };
};

export const UploadTerm: HandlerType = async props => {
    try {
        await uploadTermsApi(props.apiParameter);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};
export const LoadTerms: HandlerType = props => {
    props.dispatch(searchFilterTerms({ queryParams: { page: 1 } }));
};
export const ExecuteOnSuccess: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameters, UploadTerm, LoadTerms, ExecuteOnSuccess];

const uploadTerms = createHandlerChainRunner(chain, "UploadTerms");
export default uploadTerms;
